import { UserSwitchOutlined } from '@ant-design/icons';
import React from 'react';

export default {
    path: '/system',
    name: '系统管理',
    code: 'SystemManagement',
    routes: [
      {
        path: '/system',
        hideInMenu: true,
        component: './MenuRedirect',
      },
      {
        path: '/system/user-management',
        code: 'System-UserManagement',
        name: '用户管理',
        icon: <UserSwitchOutlined />,
        component: './System/UserManagement',
      },
    ],
  };
